import styled from 'styled-components';
import tw from 'twin.macro';

export const CheckBoxAndErrorMessageWrapper = styled.div`
  ${tw`w-full`}
  ${(props) => (props.isMarginBottomZero ? tw`mb-0` : tw`mb-4`)};
  display: ${(props) => (props.isHidden ? 'none' : 'block')};

  a {
    color: #1a73e8;
    font-weight: bold;
  }

  ${(props) => props.css}
`;

export const LabelText = styled.span`
  ${tw`text-sm leading-5 font-normal text-blue-gray-700 font-inter`}
`;

export const LabelIconWrapper = styled('div')`
  ${tw`flex items-center justify-center`}
`;

export const CheckBoxHeading = styled.span`
  align-self: flex-start;
  font-size: 16px;
  color: black;
  font-family: Inter;
  font-weight: bold;
  margin-bottom: 10px;
`;

export const CheckBoxLabelContainer = styled.div`
  ${tw`text-sm leading-5 font-normal text-blue-gray-700 items-center flex mb-4`}
`;
